import React from 'react';
import { withSearch, WithSearchProps } from '@elastic/react-search-ui';
import { __ } from '@wordpress/i18n';
import { getListingBaseUrl } from './urlLocale';

interface Props {
  className?: string;
}
const FilterSummaryComponent: React.FC<WithSearchProps & Props> = ({ filters, className }) => {
  const totalSelected = filters?.reduce((count, filter) => count + filter.values.length, 0);
  return (
    <div className={className || 'job-filter-counter'}>
      <span className="job-filter-counter--number">
        {__('Filters', 'wp-plugin-jobs')}{totalSelected > 0 ? ` (${totalSelected})` : ''}
      </span>
      {totalSelected > 0 && (
        <span className="job-filter-counter--button">
          <a
            className="erase-trace"
            href={getListingBaseUrl()}
          >
            {__('Clear all', 'wp-plugin-jobs')}
          </a>
        </span>
      )}
    </div>
  );
};
const FilterSummary = withSearch(({ filters }) => ({ filters }))(FilterSummaryComponent);
export default FilterSummary;
